import { render, staticRenderFns } from "./GoodsCode.vue?vue&type=template&id=5978ec80&scoped=true"
import script from "./GoodsCode.vue?vue&type=script&lang=js"
export * from "./GoodsCode.vue?vue&type=script&lang=js"
import style0 from "./GoodsCode.vue?vue&type=style&index=0&id=5978ec80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5978ec80",
  null
  
)

export default component.exports